import { Component } from '@verndale/core';
import { tns } from 'tiny-slider/src/tiny-slider';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      slider: this.el.querySelector('.large-image-carousel__slider'),
      buttons: this.el.querySelector('.large-image-carousel__buttons')
    };

    this.initSlider();
  }

  initSlider() {
    const slider = tns({
      container: this.dom.slider,
      loop: false,
      items: 1,
      gutter: 3,
      nav: false,
      lazyloadSelector: 'lazyload',
      controlsContainer: this.dom.buttons,
      preventScrollOnTouch: 'auto',
      responsive: {
        576: {
          items: 2
        },
        1280: {
          items: 3,
          gutter: 4
        }
      }
    });
  }
}

export default Module;
